import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  balance: BigNumber
  currency: CurrencyModel
} & ClassNameProps

export const TransferAmountBalance: React.FC<Props> = ({
  balance,
  currency,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <BalanceText>{t('common.balance')}: </BalanceText>
      <BalanceAmount>
        <AmountFormatted
          amount={balance}
          currency={currency.ticker}
          roundingMode="trunc"
        />
      </BalanceAmount>
    </Root>
  )
}

const Root = styled(Typography).attrs({
  variant: 'description-semi-bold',
  component: 'div',
})`
  margin-bottom: 8px;
`

const BalanceText = styled.span`
  color: var(--text-9);
`

const BalanceAmount = styled.span`
  color: var(--text-12);
`
